export default __webpack_public_path__ + "static/media/closeButton.1c2963ee.png";